const $ = jQuery;

$(document).ready(function () {
    init();

});

const init = () => {
    beforeAfter();
}

const beforeAfter = () => {
    $('.before-after__buttons--before').click(function(e) {
        e.preventDefault();
        $('.before-after__before').addClass('active');
        $('.before-after__after').removeClass('active');
        $(this).addClass('active');
        $('.before-after__buttons--after').removeClass('active');
    });

    $('.before-after__buttons--after').click(function(e) {
        e.preventDefault();
        $('.before-after__before').removeClass('active');
        $('.before-after__after').addClass('active');
        $(this).addClass('active');
        $('.before-after__buttons--before').removeClass('active');
    });

    $('.before-after-slider').owlCarousel({
        items: 1, // Number of items per slide
        loop: true, // Loop through items
        autoplay: true, // Autoplay the slider
        autoplayTimeout: 5000, // Time each slide is displayed
        autoplayHoverPause: true // Pause on hover
    });
}